import type { ReactNode } from 'react'
import { Drawer } from 'vaul'
import { cn } from '@/lib/cn'
import { ActionSheetBody } from './ActionSheetBody'
import type { ActionSheetOptions } from './action-sheet-store'
import styles from './ActionSheet.module.css'

type PanelOptions = Pick<ActionSheetOptions, 'title' | 'description' | 'inset' | 'actions' | 'footer' | 'size' | 'showHandle'>

export function ActionSheetPanel({ options, content, depth = 0, onActionClose }: { options: PanelOptions; content: ReactNode; depth?: number; onActionClose?: () => void }) {
  return <Drawer.Portal>
    <Drawer.Overlay className={styles.overlay} style={depth ? { zIndex: `calc(var(--z-modal) + ${depth * 2 - 1})` } : undefined} />
    <Drawer.Content className={cn(styles.panel, { [styles['panel--large']]: options.size === 'large' })}
      style={depth ? { zIndex: `calc(var(--z-modal) + ${depth * 2})` } : undefined} aria-describedby={undefined}>
      {options.showHandle !== false && <Drawer.Handle className={styles.handle} />}
      <Drawer.Title className={styles.srOnly}>{options.title ?? 'Action sheet'}</Drawer.Title>
      {options.description && <Drawer.Description className={styles.srOnly}>{options.description}</Drawer.Description>}
      <ActionSheetBody options={options} content={content} onActionClose={onActionClose} />
      {options.footer && <div className={styles.footer}>{options.footer}</div>}
    </Drawer.Content>
  </Drawer.Portal>
}
